import { useAuth } from "@/contexts/auth-provider/useAuth";
import RequestManagementTable from "./request-managment";
import Metrics from "./metrics";
import DashboardLogs from "./logs";
import { cn } from "@/utils/theme";
import { useMetricsPermissions } from "./hooks/use-metrics-perms";

const getGreetingTime = () => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return "Buenos días";
  } else if (currentHour < 18) {
    return "Buenas tardes";
  } else {
    return "Buenas noches";
  }
};

const Home = () => {
  const { authUser } = useAuth();
  const { hasActivityBlock, canSeeActivity } = useMetricsPermissions();

  return (
    <div
      data-testid="home-page"
      className={cn(
        "flex gap-4 @container",
        hasActivityBlock ? "flex-col" : "flex-row",
      )}
    >
      <div className="flex-1 flex flex-col gap-8">
        <div
          className={cn(
            "grid grid-cols-1 gap-6 laptop:gap-3 items-start",
            canSeeActivity ? "@4xl:grid-cols-[1fr_320px]" : "",
          )}
        >
          <div className="flex flex-col gap-6 self-start">
            <div data-testid="greeting-section">
              <h3
                data-testid="greeting-title"
                className="text-h3 font-semibold text-heading"
              >
                {getGreetingTime()}, {authUser?.given_name || ""}{" "}
              </h3>
              <p
                data-testid="greeting-description"
                className="text-body font-normal"
              >
                Visualiza las últimas actualizaciones de tu institución.
              </p>
            </div>
            <Metrics />
          </div>
          {canSeeActivity && hasActivityBlock && (
            <div className="w-full h-full flex flex-col gap-4 items-start">
              <h6 className="text-h6 text-heading">Actividades Recientes</h6>
              <DashboardLogs />
            </div>
          )}
        </div>
        <RequestManagementTable />
      </div>
      {canSeeActivity && !hasActivityBlock && (
        <div className="w-full max-w-[320px] flex flex-col gap-4 items-start">
          <h6 className="text-h6 text-heading">Actividades Recientes</h6>
          <DashboardLogs />
        </div>
      )}
    </div>
  );
};

export default Home;
